import React, { useEffect } from 'react';
import getConfig from 'next/config';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { createAndStartOTelSpan } from '../../helpers/open-telemetry/otel-browser-setup';

const { publicRuntimeConfig } = getConfig();

const Otel: React.FC<{}> = () => {
  const otelExporterOtlpEndpoint = publicRuntimeConfig.otelExporterOtlpEndpoint;
  const openTelemetryRegexFeatureFlag = '^(?!.*launchdarkly\\.com).*$';

  const { openTelemetryProcoreObservabilityKeepFeatureFlag } = useFlags();

  useEffect(() => {
    createAndStartOTelSpan(
      otelExporterOtlpEndpoint,
      openTelemetryRegexFeatureFlag,
      openTelemetryProcoreObservabilityKeepFeatureFlag
    );
  }, [
    otelExporterOtlpEndpoint,
    openTelemetryRegexFeatureFlag,
    openTelemetryProcoreObservabilityKeepFeatureFlag,
  ]);

  return null; // This  doesn't render anything
};

export default Otel;
